import { useMemo } from 'react';
import { EMPTY_DEFAULT } from '@/common/components/shared/table/constants';
import { DATETIME_FORMATS, DateUtils } from '@/common/utils';

export const DateWithCount = ({
  prefix,
  date,
}: {
  prefix?: string;
  date: Date | number | string | null | undefined;
}) => {
  const parsedDate = useMemo(() => DateUtils.parseDate(date), [date]);

  const showingDiff = useMemo(() => {
    if (!parsedDate) return null;

    const diff = DateUtils.getDifferenceString(parsedDate);
    let showingDiff;
    if (!diff.isFuture) {
      showingDiff = `(${diff.text} ago)`;
    } else {
      showingDiff = `(${diff.text})`;
    }

    return showingDiff;
  }, [parsedDate]);

  return (
    <>
      {prefix && `${prefix}: `}
      {parsedDate ? DateUtils.formatDate(parsedDate, DATETIME_FORMATS.MMMddyyyy) : EMPTY_DEFAULT}
      {showingDiff && <span className="text-2xs text-gray-7">&nbsp;{showingDiff}</span>}
    </>
  );
};
